export const isAvailableForReplacement = (
    gameTime: Date,
    site: number,
): boolean => {
    const now = new Date();
    switch (site) {
        case 1:
        case 4:
            const replacementCutoff = 48 * 60 * 60 * 1000;
            const diff = gameTime.getTime() - now.getTime();
            return diff > 0 && diff >= replacementCutoff;
        case 2:
        case 3:
            const eventDay = gameTime.getDay();
            const daysToWednesday =
                eventDay >= 3 ? eventDay - 3 : 7 - (3 - eventDay);
            gameTime.setDate(gameTime.getDate() - daysToWednesday);
            gameTime.setHours(12, 0, 0, 0);
            return now < gameTime;
        default:
            return false;
    }
};
